// @flow

import { useTranslator } from '@gandi/translate';

import { CommercialBlock } from 'src/Domain/CommercialBlock';

export function RenewCommercialBlock(): React.MixedElement {
  const { __ } = useTranslator();

  return (
    <CommercialBlock
      title={__('Tips to prevent losing access to your domains:')}
      commercialPoints={[
        __('Renew your domain before the expiration date to avoid any risk'),
        __(
          'Activate automatic renewal: this avoids oversights and guarantees the continuity of your services.',
        ),
        __(
          'Renew for several years: this simplifies management, secures and can sometimes be more economical.',
        ),
      ]}
      commercialPointsIconName="arrowRight"
    />
  );
}
